import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class OpenPanelMainContentRightRowConverter extends CmsConverterService<OpenPanelMainContentRightRowData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      itemsLeft: formData.st_items_left ?? defaultFSCatalog,
      itemsRight: formData.st_items_right ?? defaultFSCatalog
    }
  }
}

export const OPEN_PANEL_MAIN_CONTENT_RIGHT_ROW_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, OpenPanelMainContentRightRowData>>('OpenPanelMainContentRightRowConverter')

export interface OpenPanelMainContentRightRowData extends ConvertedComponentData {
  itemsLeft: FsCatalog;
  itemsRight: FsCatalog;
}
